<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.DESCRIPTION' | translate }}
</span>
<div class="update-options">
  <mat-radio-group [formControl]="emailEventControl">
    <div class="update-option">
      <mat-radio-button [value]="Opened">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.OPENED' | translate | automataCapitalize }}
      </mat-radio-button>
    </div>
    <div class="update-option">
      <mat-radio-button [value]="Clicked">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.CLICKED' | translate | automataCapitalize }}
      </mat-radio-button>
    </div>
    <div class="update-option">
      <mat-radio-button [value]="Bounced">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.BOUNCED' | translate | automataCapitalize }}
      </mat-radio-button>
    </div>
    <div class="update-option">
      <mat-radio-button [value]="Unsubscribed">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.EVENT_OPTIONS.UNSUBSCRIBED' | translate | automataCapitalize }}
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>
<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.ADDITIONAL_DESCRIPTION' | translate }}
</span>

<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.CAMPAIGN"
  hint="AUTOMATIONS.EDITOR.TRIGGERS.CAMPAIGN_EMAIL.HINT"
  [dataService]="campaignSelectorService"
  [formControl]="campaignIdControl"
  [supportDataPassing]="false"
  [isRequired]="(isNonPartnerAutomation$ | async) === false"
  [multiple]="false"
  [extraData]="{ prependAnyOption: true }"
  (finishedInitialLoading)="finishedLoadingSelector()"
></automata-automation-replacement-chips>
